import { Injectable } from '@angular/core';
import { DedupSurface, DedupSurfaceConfig } from './dedup.model';

@Injectable({ providedIn: 'root' })
export class DedupService {
  private readonly configs: Record<DedupSurface, DedupSurfaceConfig> = {
    library: {
      titleKey: 'tenders.responses.documents.dedup.library-title-many',
      titleKeyOne: 'tenders.responses.documents.dedup.library-title-one',
      subtitleKey: 'tenders.responses.documents.dedup.library-subtitle-many',
      subtitleKeyOne: 'tenders.responses.documents.dedup.library-subtitle-one',
      keepLabelKey: 'tenders.responses.documents.dedup.keep-library',
      replaceLabelKey: 'tenders.responses.documents.dedup.replace',
      primaryAction: 'keep',
      resolvedKeepKey: 'tenders.responses.documents.dedup.resolved-kept-library',
      resolvedReplaceKey: 'tenders.responses.documents.dedup.resolved-replaced',
    },
    'project-picker': {
      titleKey: 'tenders.responses.documents.dedup.picker-title-many',
      titleKeyOne: 'tenders.responses.documents.dedup.picker-title-one',
      subtitleKey: 'tenders.responses.documents.dedup.picker-subtitle-many',
      subtitleKeyOne: 'tenders.responses.documents.dedup.picker-subtitle-one',
      keepLabelKey: 'tenders.responses.documents.dedup.use-library',
      replaceLabelKey: 'tenders.responses.documents.dedup.continue-import',
      primaryAction: 'keep',
      resolvedKeepKey: 'tenders.responses.documents.dedup.resolved-used-library',
      resolvedReplaceKey: 'tenders.responses.documents.dedup.resolved-imported',
    },
    'push-to-library': {
      titleKey: 'tenders.responses.documents.dedup.push-title',
      subtitleKey: 'tenders.responses.documents.dedup.push-subtitle',
      keepLabelKey: 'tenders.responses.documents.dedup.cancel',
      replaceLabelKey: 'tenders.responses.documents.dedup.replace',
      primaryAction: 'keep',
      resolvedKeepKey: 'tenders.responses.documents.dedup.resolved-cancelled',
      resolvedReplaceKey: 'tenders.responses.documents.dedup.resolved-replaced',
    },
    project: {
      titleKey: 'tenders.responses.documents.dedup.project-title-many',
      titleKeyOne: 'tenders.responses.documents.dedup.project-title-one',
      subtitleKey: 'tenders.responses.documents.dedup.project-subtitle-many',
      subtitleKeyOne: 'tenders.responses.documents.dedup.project-subtitle-one',
      keepLabelKey: 'tenders.responses.documents.dedup.keep',
      replaceLabelKey: 'tenders.responses.documents.dedup.replace',
      primaryAction: 'replace',
      resolvedKeepKey: 'tenders.responses.documents.dedup.resolved-kept',
      resolvedReplaceKey: 'tenders.responses.documents.dedup.resolved-replaced',
    },
  };

  getConfig(surface: DedupSurface): DedupSurfaceConfig {
    return this.configs[surface];
  }
}
